import type { ComponentProps } from "react";
import Select, { type StylesConfig } from "react-select";
import { FixedSizeList as List } from "react-window";

const OPTION_HEIGHT = 40;

const moxieSelectStyles: StylesConfig = {
	control: (base, state) => ({
		...base,
		minHeight: 50,
		borderRadius: 10,
		borderColor: state.isFocused ? "#17c5d4" : "#e5eaf2",
		boxShadow: state.isFocused
			? "0 0 0 3px rgba(23, 197, 212, 0.18)"
			: "0 1px 2px rgba(5, 1, 24, 0.04)",
		backgroundColor: "#fff",
		"&:hover": {
			borderColor: "#17c5d4",
		},
	}),
	valueContainer: (base) => ({
		...base,
		padding: "2px 16px",
	}),
	singleValue: (base) => ({
		...base,
		color: "#1a1a1a",
		fontWeight: 500,
	}),
	placeholder: (base) => ({
		...base,
		color: "#2d4f7a",
	}),
	indicatorSeparator: () => ({
		display: "none",
	}),
	dropdownIndicator: (base) => ({
		...base,
		color: "#2d4f7a",
	}),
	menu: (base) => ({
		...base,
		borderRadius: 10,
		border: "1px solid #e5eaf2",
		boxShadow: "0 8px 28px rgba(5, 1, 24, 0.08)",
		overflow: "hidden",
		zIndex: 2000,
	}),
	menuList: (base) => ({
		...base,
		padding: 6,
	}),
	option: (base, state) => ({
		...base,
		borderRadius: 10,
		backgroundColor: state.isSelected
			? "#e8f9fb"
			: state.isFocused
				? "#eef4fa"
				: "transparent",
		color: state.isSelected ? "#0fa8b8" : "#1e3a5f",
		fontWeight: state.isSelected ? 600 : 500,
		cursor: "pointer",
	}),
};

// biome-ignore lint/suspicious/noExplicitAny: Temporary solution
const MenuList = (props: any) => {
	const { options, children, maxHeight, getValue } = props;
	const [selected] = getValue();

	const selectedIndex = options.findIndex(
		// biome-ignore lint/suspicious/noExplicitAny: Temporary solution
		(option: any) => option.value === selected?.value,
	);
	const initialOffset = selectedIndex > -1 ? selectedIndex * OPTION_HEIGHT : 0;
	const height = Math.min(maxHeight, options.length * OPTION_HEIGHT);

	return (
		<List
			height={height}
			itemCount={children.length}
			itemSize={OPTION_HEIGHT}
			initialScrollOffset={initialOffset}
			width="100%"
		>
			{({ index, style }) => <div style={style}>{children[index]}</div>}
		</List>
	);
};

export function VirtualizedSelectTmp<T>(
	props: ComponentProps<typeof Select<T>>,
) {
	const { components, styles, ...rest } = props;
	return (
		<Select
			components={{ MenuList, ...components }}
			styles={
				(styles ?? moxieSelectStyles) as ComponentProps<
					typeof Select<T>
				>["styles"]
			}
			{...rest}
		/>
	);
}
